import {Component} from "react";
import signUp_bg from "../../../../assets/img/login/login-background.jpg-v1.jpg";
import React from "react";
import './style.scss';
import {Col} from "reactstrap";

class App extends Component {

  render() {

    return (
      <Col xs={6} md={7} lg={8} sm={6} className={'public-signup-layout-img-div'}>
        <img src={signUp_bg} alt={"."} className={"ori-img"}/>
        <img src={signUp_bg} alt={"."} className={"blur-img"}/>
      </Col>
    );
  }
}

export default App
